import React from 'react';
import './NavItems.scss';
import NavItem from './NavItem/NavItem';
import {useLocation} from 'react-router-dom';


const NavigationItems = () => {
    let location = useLocation().pathname;
    return (
        <ul className={'NavItems'}>
            <NavItem value={'Home'} to={'/#'}/>
            <NavItem value={'Reviews'} to={'/#'} scroll={"Reviews"}/>
            <NavItem value={'Services'} to={'/services#'}/>
            <NavItem value={'Contact Us'} to={location+"#"} scroll={"Footer"}/>
        </ul>
    );
};

export default NavigationItems;
